import { Constants } from '../constants';
import { LabelsModeled } from '../types/LabelsModeled';
import { PrivacyShieldLabels } from '../types/PrivacyShieldLabels';
import { getLabelsByLanguage } from './getLabelsByLanguage';
import { LabelKeysOverrides } from '../types/LabelKeysOverrides';

const NAME_PLACEHOLDER = '$NAME';

export const getLabelsToPlaceholder = (
  language: string,
  technologyName: string,
  labels: LabelsModeled[],
  legalName: string,
  keyOverrides?: LabelKeysOverrides,
): PrivacyShieldLabels => {
  const name = technologyName?.toLowerCase().replace(/\s|_/g, '');
  const labelsCurrentLanguage = getLabelsByLanguage(language, labels);
  const labelsDefaultLanguage = getLabelsByLanguage(Constants.DEFAULT_LANGUAGE_CODE, labels);
  const defaultLabels = labelsDefaultLanguage?.[Constants.DEFAULT_LANGUAGE_CODE];
  const currentLabels = labelsCurrentLanguage?.[language];

  function getLabelOrOverride(defaultKey: string, overrideKey?: string): string {
    if (!!overrideKey) {
      return (
        currentLabels?.[`${name}_${overrideKey}`] ||
        defaultLabels?.[`${name}_${overrideKey}`] ||
        currentLabels?.[`${name}_${defaultKey}`] ||
        defaultLabels?.[`${name}_${defaultKey}`]
      );
    } else {
      return currentLabels?.[`${name}_${defaultKey}`] || defaultLabels?.[`${name}_${defaultKey}`];
    }
  }

  let headlineText = getLabelOrOverride('headline', keyOverrides?.headline);
  headlineText = headlineText?.replace(NAME_PLACEHOLDER, legalName);

  const descriptionText = getLabelOrOverride('description', keyOverrides?.description);
  const primaryButtonText: string =
    currentLabels?.[`${name}_primaryButton`] || defaultLabels?.[`${name}_primaryButton`];
  const secondaryButtonText: string =
    currentLabels?.[`${name}_secondaryButton`] || defaultLabels?.[`${name}_secondaryButton`];
  const tertiaryButtonText: string =
    currentLabels?.[`${name}_tertiaryButton`] || defaultLabels?.[`${name}_tertiaryButton`];

  return {
    headlineText,
    descriptionText,
    primaryButtonText,
    secondaryButtonText,
    tertiaryButtonText,
  };
};
